export const FEATURE_FLAGS = {
  AGENT_BOTS: 'agent_bots',
  AGENT_MANAGEMENT: 'agent_management',
  ASSIGNMENT_V2: 'assignment_v2',
  AUTO_RESOLVE_CONVERSATIONS: 'auto_resolve_conversations',
  AUTOMATIONS: 'automations',
  CAMPAIGNS: 'campaigns',
  WHATSAPP_CAMPAIGNS: 'whatsapp_campaign',
  CANNED_RESPONSES: 'canned_responses',
  CRM: 'crm',
  PROSPECTING: 'prospecting',
  CUSTOM_ATTRIBUTES: 'custom_attributes',
  INBOX_MANAGEMENT: 'inbox_management',
  INTEGRATIONS: 'integrations',
  LABELS: 'labels',
  MACROS: 'macros',
  HELP_CENTER: 'help_center',
  REPORTS: 'reports',
  TEAM_MANAGEMENT: 'team_management',
  VOICE_RECORDER: 'voice_recorder',
  AUDIT_LOGS: 'audit_logs',
  INBOX_VIEW: 'inbox_view',
  SLA: 'sla',
  RESPONSE_BOT: 'response_bot',
  CHANNEL_EMAIL: 'channel_email',
  CHANNEL_FACEBOOK: 'channel_facebook',
  CHANNEL_TWITTER: 'channel_twitter',
  CHANNEL_WEBSITE: 'channel_website',
  CUSTOM_REPLY_DOMAIN: 'custom_reply_domain',
  CUSTOM_REPLY_EMAIL: 'custom_reply_email',
  DISABLE_BRANDING: 'disable_branding',
  EMAIL_CONTINUITY_ON_API_CHANNEL: 'email_continuity_on_api_channel',
  INBOUND_EMAILS: 'inbound_emails',
  IP_LOOKUP: 'ip_lookup',
  LINEAR: 'linear_integration',
  CAPTAIN: 'captain_integration',
  CUSTOM_ROLES: 'custom_roles',
  CHATWOOT_V4: 'chatwoot_v4',
  REPORT_V4: 'report_v4',
  CHANNEL_INSTAGRAM: 'channel_instagram',
  CONTACT_CHATWOOT_SUPPORT_TEAM: 'contact_chatwoot_support_team',
  CAPTAIN_V2: 'captain_integration_v2',
  SAML: 'saml',
  QUOTED_EMAIL_REPLY: 'quoted_email_reply',
  COMPANIES: 'companies',
  BULK_SCHEDULED_MESSAGES: 'bulk_scheduled_messages',
  INTERNAL_CHAT: 'internal_chat',
  CALENDAR: 'calendar',
  SCHEDULED_MESSAGES: 'scheduled_messages',
  AUDIO_TRANSCRIPTION: 'audio_transcription',
  CAPTAIN_AGENT: 'captain_agent',
  CAPTAIN_KNOWLEDGE_BASE: 'captain_knowledge_base',
  WHATSAPP_CLOUD: 'whatsapp_cloud',
};

export const PREMIUM_FEATURES = [
  FEATURE_FLAGS.SLA,
  FEATURE_FLAGS.CAPTAIN,
  FEATURE_FLAGS.CUSTOM_ROLES,
  FEATURE_FLAGS.AUDIT_LOGS,
  FEATURE_FLAGS.HELP_CENTER,
  FEATURE_FLAGS.SAML,
];

export const MANUAL_ONLY_PLAN_FEATURES = [FEATURE_FLAGS.PROSPECTING];

export const YESZAP_PLAN_FEATURES = [
  ...MANUAL_ONLY_PLAN_FEATURES,
  FEATURE_FLAGS.CRM,
  FEATURE_FLAGS.INTERNAL_CHAT,
  FEATURE_FLAGS.CALENDAR,
  FEATURE_FLAGS.SCHEDULED_MESSAGES,
  FEATURE_FLAGS.AUDIO_TRANSCRIPTION,
  FEATURE_FLAGS.CAPTAIN_AGENT,
  FEATURE_FLAGS.CAPTAIN_KNOWLEDGE_BASE,
];
